//Dependencies
import React, { useEffect, useCallback, useState } from 'react';
import { Circle, Map, TileLayer, Marker, CircleMarker, Tooltip } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { useDispatch } from 'react-redux';
import { Icon } from "leaflet";
//Scripts
import { PointInCircle } from '../../../scripts/Helpers';

require('react-leaflet-markercluster/dist/styles.min.css');

const markerMain = new Icon(
  {
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/bettercityio.appspot.com/o/markers%2Fmarker03.png?alt=media&token=e343be70-0e88-4f2c-acd6-fc2008aa6805',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -34],
  });

const markerBlue = new Icon(
  {
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/bettercityio.appspot.com/o/markers%2Fmarker09.png?alt=media&token=1b29ff2d-639c-4075-a864-c3e57d4332aa',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -34],
  });

const MapPage03 = (props) =>
{
  const dispatch = useDispatch();

  const { group, last, layers, liveLocation, location, center, filter, height, markers, paddingBottom, paddingTop, zoom } = props;  
  
  const [ markerList01, setMarkerList01 ] = useState(null);
  const [ markerList02, setMarkerList02 ] = useState(null);
  
  const layer1 = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  const layer2 = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  const clickMarker = useCallback((info) => 
  {
    dispatch({type: 'SET_CENTER', center : info.location});

    if(zoom < 14 )
      {
        setTimeout(() => 
        {
          dispatch({type: 'SET_ZOOM', zoom : 14});
        }, 400);
      }
  }, [dispatch, zoom]); 

  const dragMap = useCallback((e) => 
  {
    dispatch({type: 'SET_CENTER', center : e.target.getCenter()});
  }, [dispatch]); 

  const markerDrag = (e) =>
  {
    let location = [e.target.getLatLng().lat.toFixed(6), e.target.getLatLng().lng.toFixed(6)];
    
    dispatch({type: 'SET_LOCATION', location : location});
    dispatch({type: 'SET_CENTER', center : location});
  }

  /* ALL MARKERS */
  useEffect(() => 
  {
    dispatch({type: 'LOADING', loading : true});

    let markerArray01 = [];

    try
    {
      for(let i = 0; i < Object.keys(markers).length; i++)
      {
        let info = markers[Object.keys(markers)[i]];
        let reportsLength = Object.keys(info.reports).length;
        let lastReport = Object.keys(info.reports).find(f1 => info.reports[f1].id === reportsLength);

        let markerColor = info.reports[lastReport].type === 'damage' || info.reports[lastReport].type === 'update' ? '#f2261c' : '#1cf244';

        let marker =
          <CircleMarker
            key         = {i}
            center      = {info.location}
            fill        = "true"
            color       = '#1f1f1f'
            fillColor   = {markerColor}
            opacity     = {1}
            fillOpacity = {0.7}
            weight      = {2}

            onClick     = {() => clickMarker(info)}
          />       
              
        markerArray01.push({...marker});
      };

      setMarkerList01(markerArray01);
    } 
    catch (error) 
    {
      console.log(error);
    }

    dispatch({type: 'LOADING', loading : false});
  }, [clickMarker, dispatch, markers]);

  /* FILTERS */
  useEffect(() => 
  {
    let markerArray = [];

    try
    {
      markerArray = Object.keys(markers).map((m1, i) =>
      {
        let info = {...markers[m1]};
        let reportsLength = Object.keys(info.reports).length;
        let lastReport = Object.keys(info.reports).find(f1 => info.reports[f1].id === reportsLength);
        
        let markerColor = info.reports[lastReport].type === 'damage' || info.reports[lastReport].type === 'update' ? '#f2261c' : '#1cf244';

        let marker = 
          <CircleMarker
            key         = {i}
            center      = {info.location}
            fill        = "true"
            color       = '#1f1f1f'
            fillColor   = {markerColor}
            opacity     = {1}
            fillOpacity = {0.7}
            weight      = {2}

            onClick = {() => clickMarker(info)}
          />

        if(info.damageType === filter)
        {
          return marker;
        }
        else
        {
          return null;
        }
      });

      setMarkerList02(markerArray);
    } 
    catch (error) 
    {
      console.log(error);
    }    
  }, [clickMarker, filter, markers]);

  const mapZoom = (e) =>
  {
    dispatch({type: 'SET_ZOOM', zoom : e.target.getZoom()});
  }

  return(
    <div
      style = {{height : height, width : '100%', paddingTop : paddingTop, paddingBottom : paddingBottom }}
    >
      <Map
        center = {center} 
        zoom = {zoom} 
        style = {{height : '100%', width : '100%'}}
        onzoomend = {(e) => mapZoom(e)} 
        ondragend = {(e) => dragMap(e)}
      >
        <TileLayer
          url = {layers ? layer2 : layer1}
          minZoom = {5}
          maxZoom = {19}
        />
        
        {group === true &&
          <MarkerClusterGroup>
             {!filter && markerList01}
          </MarkerClusterGroup>
        }

        {group === false &&
          !filter && markerList01
        }
        
        {last &&
          <Marker
            position = {last.location}
            icon = {markerBlue}
            onClick = {() => clickMarker(last)}
          />
        }

        {location &&
          <React.Fragment>
            <Marker
              draggable = {true}
              position = {location}
              icon = {markerMain}
              onDragend = {(e) => markerDrag(e)}
            >
              {(liveLocation && location) && PointInCircle(location ,liveLocation, 30) &&
                 <Tooltip direction = "right" offset = {[20, -20]} permanent>{`APORTE`}</Tooltip>
              }

              {(liveLocation && location) && !PointInCircle(location ,liveLocation, 30) &&
                 <Tooltip direction = "right" offset = {[20, -20]} permanent>{`FUERA DE RANGO`}</Tooltip>
              }              
            </Marker>
          </React.Fragment>
        }

        {liveLocation &&
          <React.Fragment>
            <CircleMarker
              center = {liveLocation}              
              fill = "true"
              color = '#0F52BA'
              fillColor = '#0F52BA'
              opacity = {1}
              fillOpacity = {1}
              weight = {2}
            />
            
            {PointInCircle(location ,liveLocation, 30) &&
              <Circle
                center = {liveLocation}
                fillColor = "green"
                radius = {34}
              />
            }
            
            {!PointInCircle(location ,liveLocation, 30) &&
              <Circle
                center = {liveLocation}
                fillColor = "red"
                radius = {34}
              />
            }  
          </React.Fragment>
        }      
       
        {filter && markerList02}
      </Map>
    </div>
  );
}

export default MapPage03;